
<template>
  <div>
    <div class="ml-16 md:ml-8 md:mr-8 mt-10">
      <div class="flex justify-between">
        <div>
          <p class="text-5xl leading-8">let's learn</p>
      <p class="text-5xl font-bold">something new</p>
        </div>
        <div> 
          <i class="fas fa-times-circle cursor-pointer mr-10 text-black text-4xl z-50 hover:opacity-50"
          @click="close()"></i>

        </div>
      </div>
      <div class="sm:flex mt-10">
        <div
          class="flex flex-wrap md:mr-2 justify-center grid grid-cols-4 gap-4"
        >
          <div
           v-bind:style="{ 'background-color': subjectColor(item) }"
            class="rounded-3xl card-width mb-4 cursor-pointer hover:opacity-50"
            v-for="item in subjectsList"
            :key="item.id"
            @click="selectSubject(item)"
           
          >
            <div class="justify-center pt-4 h-48 mb-4 block">
              <img :src="contentImage(item)" alt="" />
            </div>
            <div class="px-6 pb-4 pt-10 flex justify-between ">
              <h1 class="  text-base md:text-lg lg:text-2xl"
              v-bind:class="hasSubject(item) ? 'text-gray-200 font-medium' : 'text-gray-600 font-bold' ">
                {{ item.title }}
              </h1>
              <i v-if="hasSubject(item)" class="text-2xl text-white far fa-check-circle opacity-25 mt-2"
                              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalSlide :show="showModalSubject" @closeModal="closeModelSubject">
      <template v-slot:header-icon>
        <i class="fas fa-book"></i>
      </template>
      <template v-slot:header-title>
        {{ selectedSubjectTitle }}
        <div class="text-xs">View subject details and information.</div>
      </template>
      <template v-slot:body>
      <p>Advert and subject details to appear here</p>
      <p>Ability to upgrade / add on?</p>

      </template>
    </ModalSlide>

   


  </div>
</template>
<script>
import { mapGetters } from "vuex";
const ModalSlide = () => import("@/components/ModalSlide.vue");


export default {
  name: "Curriculum",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      subjects: "subjects",
      authStatus: "authStatus",
    }),
    selectedSubjectTitle() {
      return this.selectedSubject != undefined 
      ? this.selectedSubject.title
      : "Learn something new"
    }
  },
  mounted() {
    this.ownsSubjects = this.subjects.list;
    this.subjectsList = this.subjects.systemSubjects
  },
  data() {
    return {
      subjectsList: [],//subjects.list,
      ownsSubjects: [],
      showModalSubject: false,
      selectedSubject: undefined
    };
  },
  methods: {
    contentImage(item) {
      return require("@/assets/images/subjects/" + item.key_value + ".png");
    },
    hasSubject(item) {
      return this.ownsSubjects.find((att) => att.id === item.id);
    },
    subjectColor(item) {
      return this.hasSubject(item) ? "#" + item.color_hex : "#f7fafc";
    },
    close() {
      this.$router.push("/");
    },
    selectSubject(item) {
      if (this.hasSubject(item)) {
        this.$store.commit("setSubject", item);
        this.close()
      } else {
        this.selectedSubject = item
        this.showModalSubject = true
      }
    },
    closeModelSubject() {
      this.showModalSubject = false
      this.selectedSubject = undefined
     
    }
  },
  components: {
    ModalSlide,
  },
};
</script>
<style scoped>
</style>